import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footersocket from './Footersocket';
import ScrollToTop from './ScrollToTop';
import { PAGES_URLS } from '../../lib/constants/routes';

const Layout: React.FC = () => {
  const location = useLocation();

  // Define the paths where the footer should be hidden
  const hideFooterPaths = [PAGES_URLS.Login, ];

  const hideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      <Header />
      <div id="main">
        <Outlet />
      </div>
      {/* Conditionally render the footer */}
      {!hideFooter && <Footersocket />}
    </>
  );
};

export default Layout;
